import { render, staticRenderFns } from "./header-new.vue?vue&type=template&id=ef1c343a&scoped=true&"
import script from "./header-new.vue?vue&type=script&lang=js&"
export * from "./header-new.vue?vue&type=script&lang=js&"
import style0 from "./header-new.vue?vue&type=style&index=0&id=ef1c343a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1c343a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef1c343a')) {
      api.createRecord('ef1c343a', component.options)
    } else {
      api.reload('ef1c343a', component.options)
    }
    module.hot.accept("./header-new.vue?vue&type=template&id=ef1c343a&scoped=true&", function () {
      api.rerender('ef1c343a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/header-new.vue"
export default component.exports